/**
 * Classe responsável por criar uma grid simples apenas para visualizacao de dados
 *
 * @author: kete
 */


Monet.UI = Monet.UI || {};
Monet.UI.TableView = Monet.UI.TableView || {};

Monet.UI.TableView = (function () {

    function TableView () {
        var _headers = null;
        var _lines = null;
        var _id = null;
        this.baseEl = document.createElement('div');
        this.table = document.createElement('table');
        this.baseEl.className = 'BaseMonetUITableView';
        this.table.className = 'MonetUITableView';

        this.baseEl.appendChild(this.table);

        //recebe uma lista de strings que serão adicionadas na primeira linha da grid.
        this.setHeaders = function (headerCells) {
            _headers = headerCells;
        };

        this.setLines = function (lines) {
            _lines = lines;
        };

        this.addLine = function (line) {
            if (!_lines) {
                _lines = { data: [] };
            }
            _lines.data.push(line);
        };

        this.setId = function (id) {
            _id = id;
            this.baseEl.className += ' ' + id;
        };

        this.generateLink = function (value, onclick, href) {
            var link = document.createElement('a');
            link.href = href;
            link.onclick = onclick;
            link.innerHTML = value;
            return link;
        };

        this.renderHeader = function () {
            if (_headers) {
                var tr = document.createElement('tr');
                this.table.appendChild(tr);

                for (var i = 0, length = _headers.length; i < length; i++) {
                    var td = document.createElement('td');
                    td.innerHTML = _headers[i];
                    tr.appendChild(td);
                }
            }
        };

        this.renderLines = function () {
            if (_lines) {
                var data = _lines.data;

                //Renderiza todas as linhas
                for (var i = 0, length = data.length; i < length; i++) {

                    var tr = document.createElement('tr');

                    //Renderiza todas as celulas de cada linha
                    //As celulas são objetos Monet.UI.TableViewCell
                    var line = data[i];
                    for (var j = 0, lineLength = line.length; j < lineLength; j++) {
                        var td = document.createElement('td');
                        var value = line[j].render() || " - ";

                        if (typeof value === 'string') {
                            td.setAttribute('cellvalue', value);
                            value = document.createTextNode(value);
                        }
                        td.appendChild(value);
                        tr.appendChild(td);
                    }

                    this.table.appendChild(tr);
                }
            }
        };

        this.render = function () {
            this.renderHeader();
            this.renderLines();
            return this.baseEl;
        };

    }

    return TableView;

})();